import { ExpandableItemProps } from "components/ui/ExpandableComponent/types";

import "./style.scss";

const ExpandableItem = ({ children }: ExpandableItemProps) => {
    return <div className="flex-row align-center expandable-item">{children}</div>;
};

export default ExpandableItem;
